export default "__VITE_ASSET__dd6b0be2__"